export default __webpack_public_path__ + "static/media/momart.19a21725.png";